import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  Input,
  Select,
  Textarea,
  Button,
  LoaderComponent,
} from 'components/common';
import { axiosData } from 'services/axiosData';
// import { axiosData } from 'services/fetchInterceptor';

interface UserData {
  firstname: string;
  lastname: string;
  usernme: string;
  email: string;
  country: string;
  state: string;
  address: string;
  phone: string;
  bio: string;
}

const EditProfile = () => {
  const [userData, setUserData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    axiosData
      .get('/user/me')
      .then((response) => {
        setUserData(response);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .then(() => {
        setLoading(false);
      });
  }, []);

  const createUser = (values: UserData) => {
    setLoading(true);
    axiosData
      .post('/user', values)
      .then((response: any) => {
        console.log('response', response);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const updateUser = (values: UserData) => {
    setLoading(true);
    axiosData
      .put('/user/update-me', values)
      .then((response: any) => {
        console.log('response', response);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const handleFormSubmit = (values: any) => {
    if (userData?.firstname || userData?.username) {
      // update records
      updateUser(values);
    } else {
      // create record
      createUser(values);
    }
  };

  const EditProfileSchema = Yup.object().shape({
    firstname: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    lastname: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    email: Yup.string().email('Invalid email').required('Required'),
    username: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    country: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    address: Yup.string().required('Required'),
    postalCode: Yup.string().required('Required'),
    phone: Yup.string().required('Required'),
    bio: Yup.string().required('Required'),
  });

  return (
    <div className="">
      {loading && <LoaderComponent />}
      <div className="rounded-3xl border border-bg-form p-14">
        <Formik
          initialValues={{
            firstname: '',
            lastname: '',
            username: '',
            email: '',
            country: '',
            state: '',
            city: '',
            address: '',
            postalCode: '',
            phone: '',
            bio: '',
          }}
          validationSchema={EditProfileSchema}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
        >
          {(props) => {
            const { values, errors, isSubmitting } = props || {};
            return (
              <Form className="">
                <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-14">
                  <Input
                    label="First Name"
                    placeholder="John"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="text"
                    name="firstname"
                    disabled={isSubmitting}
                    value={values?.firstname}
                    error={errors?.firstname}
                    {...props}
                  />

                  <Input
                    label="Last Name"
                    placeholder="Doe"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="text"
                    name="lastname"
                    disabled={isSubmitting}
                    value={values?.lastname}
                    error={errors?.lastname}
                    {...props}
                  />

                  <Input
                    label="Username"
                    placeholder="John4Doe"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="text"
                    name="username"
                    disabled={isSubmitting}
                    value={values?.username}
                    error={errors?.username}
                    {...props}
                  />

                  <Input
                    label="Email"
                    placeholder="johndoe@gmail.com"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="email"
                    name="email"
                    disabled={isSubmitting}
                    value={values?.email}
                    error={errors?.email}
                    {...props}
                  />

                  <Input
                    label="Country"
                    placeholder="United States of America"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="text"
                    name="country"
                    disabled={isSubmitting}
                    value={values?.country}
                    error={errors?.country}
                    {...props}
                  />

                  <Select
                    label="State"
                    placeholder="Texas"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="select"
                    name="state"
                    disabled={isSubmitting}
                    value={values?.state}
                    error={errors?.state}
                    {...props}
                  >
                    <option value="Texas">Texas</option>
                    <option value="Florida">Florida</option>
                    <option value="California">California</option>
                  </Select>

                  <Select
                    label="City"
                    placeholder="Houston"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="select"
                    name="city"
                    disabled={isSubmitting}
                    value={values?.city}
                    error={errors?.city}
                    {...props}
                  >
                    <option value="Houston">Houston</option>
                    <option value="Houston">Ikeja</option>
                  </Select>

                  <Input
                    label="Address"
                    placeholder="Houston"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="text"
                    name="address"
                    disabled={isSubmitting}
                    value={values?.address}
                    error={errors?.address}
                    {...props}
                  />

                  <Input
                    label="Postal Code"
                    placeholder="101245"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="number"
                    name="postalCode"
                    disabled={isSubmitting}
                    value={values?.postalCode}
                    error={errors?.postalCode}
                    {...props}
                  />

                  <Input
                    label="Phone number"
                    placeholder="+234 9123456789"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="number"
                    name="phone"
                    disabled={isSubmitting}
                    value={values?.phone}
                    error={errors?.phone}
                    {...props}
                  />
                </div>
                <div className="mt-12">
                  <Textarea
                    label="Bio"
                    className="bg-transparent border border-primary-2 py-2 px-3 focus:outline-none text-white"
                    type="text"
                    name="bio"
                    cols="8"
                    rows="6"
                    max="300"
                    disabled={isSubmitting}
                    value={values?.bio}
                    error={errors?.bio}
                    {...props}
                  />
                </div>
                <div className="flex justify-end my-8">
                  <Button
                    className="px-12 py-3"
                    type="submit"
                    variant="primary"
                  >
                    Create
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default EditProfile;
